import React from 'react';

const RoomClientContext = React.createContext();

export default RoomClientContext;

export function withRoomClientContext(Component) {
  return (props) => (
    <RoomClientContext.Consumer>
      {(roomClient) => <Component {...props} roomClient={roomClient} />}
    </RoomClientContext.Consumer>
  );
}
